import { render } from "./receipts_index.vue?vue&type=template&id=135459fd&scoped=true"
import script from "./receipts_index.vue?vue&type=script&lang=js"
export * from "./receipts_index.vue?vue&type=script&lang=js"

import "./receipts_index.vue?vue&type=style&index=0&id=135459fd&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135459fd"]])

export default __exports__